module.exports = __webpack_public_path__ + "img/entertainment-4.d86be7b5.jpg";